<div style="margin: 20% auto; width: 300px; height: 300px; opacity: .05;">
  <img src="../../../assets/logo.png" alt="" width="100" />
</div>